/* global axios */
import ApiClient from './ApiClient';

class InboxLabelsAPI extends ApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  getLabels(inboxId) {
    return this.get(`${inboxId}/labels`);
  }

  getHiddenLabels(inboxId) {
    return this.get(`${inboxId}/labels/hidden`);
  }

  // Nascondere una cartella è una preferenza locale dell'account: non passa dal
  // servizio di sincronizzazione e non tocca show_on_sidebar, che sui canali IMAP
  // decide quali cartelle vengono lette.
  setLabelHidden(inboxId, labelId, hidden) {
    return axios.patch(`${this.url}/${inboxId}/labels/${labelId}`, { hidden });
  }
}

export default new InboxLabelsAPI();
